import React, { use, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import style from '../Profile/profileView.module.css'
import { database, storageRef } from '../../utils/firebase'
import { path } from '../../utils/const'
import Spinner from '../../components/Spinner'
import BackComponent from '../../components/BackComponent/BackComponent'
import { actions } from '../../slices/patient.slices'
import moment from 'moment'
import qs from 'qs'
import { sendToUserLabAndImaging } from 'pages/labRequisitions/APIS'
import {checkAllStatuses} from '../../utils/functions'
// eslint-disable-next-line import/imports-first
// eslint-disable-next-line import/imports-first

function SendMail(props) {
  const emailUrl = process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL + '/sendFilesWithEmail'
  const navigate = useNavigate()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  let [sendMailReason, setSendMailReason] = useState('')
  let [mailReason, setMailReason] = useState('')
  const [chatID, setChatID] = useState(null)
  const [loading, setLoading] = useState(false)
  const delegateConvoObj = useSelector((state) => state.patient.delegateData)
  const patient = useSelector((state) => state.patient.patientData)

  const { me } = useSelector((state) => state.app)
  const dispatch = useDispatch()
  const [pathName, setPathName] = useState('')
  const [labReq, setlabReq] = useState('')
  const [adminDoctorEmail, setAdminDoctorEmail] = useState('')
  const [medicalNoteLink, setMedicalNoteLink] = useState('')
  const [imageReq, setImageReq] = useState('')
  const [prescriptionLink, setPrescriptionLink] = useState('')
  const email = useSelector((state) => state.patient.doctorEmail)
  const archiveID = useSelector((state) => state.patient.archiveId)
  let archiveId
  // let pathName = ''
  let emailBody = ''
  let attachment = ''

  const navigateToConsultation = (archiveID) => {
    const params = new URLSearchParams(window.location.search);
    params.set('archiveId', archiveID);
    navigate(`${path.consultation}?${params.toString()}`, { replace: true });
  };

  useEffect(async () => {
    const reason = query.get('reason')
    archiveId = query.get('archiveId')
    const pathName = query.get('pathName')
    setPathName(pathName)
    setChatID(archiveId || null)
    setMailReason(reason || null)
  }, [])

  const navigateBack = () => {
    navigate(-1)
  }

  useEffect(async () => {

    if (archiveID !== archiveId) {
      dispatch(actions.fetchDelegateData(archiveId))
    }
  }, [archiveID, archiveId])

 useEffect(async () => {

    if (delegateConvoObj?.doctorName ) {

      const adminDoctorName = delegateConvoObj?.doctorName.toLowerCase().replace(/\s+/g, '');
      const doctorEmail = await database.ref(`medicalDirective/doctors/${adminDoctorName}/email`).once('value').then((snapshot) => snapshot.val())
       setAdminDoctorEmail(doctorEmail)
    }
  }, [delegateConvoObj])


  const handleImageSelection = (event) => {
    const { files } = event.target
    formik.setFieldValue('image', files)

  }

  const tempLabData = async (archiveID) => {
    try {

      const labReq = await database.ref(`/tempUserNode/userLabResult/${archiveID}/labForms`).once('value').then((snapshot) => snapshot.val())
      if (labReq) {
        const formsArray = Object.values(labReq);
         const latestForm = formsArray.reduce((latest, current) => {
        return current.timestamp > (latest?.timestamp || 0) ? current : latest;
      }, null);

      if (latestForm) {
         const labLink = {
          url: latestForm.file,
          fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
          type: 'application/pdf',
          timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
        };
        setlabReq([labLink]);  
      } 
      }
      }
    catch (error) { 
      console.error('Error fetching lab data:', error);
    }
  }

  const tempImageData = async (archiveID) => {
    try {

      const ImageReq = await database.ref(`/tempUserNode/userImageResult/${archiveID}/labForms`).once('value').then((snapshot) => snapshot.val())
      if (ImageReq) {
        const formsArray = Object.values(ImageReq);
         const latestForm = formsArray.reduce((latest, current) => {
        return current.timestamp > (latest?.timestamp || 0) ? current : latest;
      }, null);

      if (latestForm) {
         const imageLink = {
          url: latestForm.file,
          fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
          type: 'application/pdf',
          timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
        };
        setImageReq([imageLink]);  
      } 
      }
      }
    catch (error) { 
      console.error('Error fetching lab data:', error);
    }
  }

  const tempNoteData = async (archiveID) => {
    try {

      const noteReq = await database.ref(`/tempUserNode/userMedicalNote/${archiveID}/notes`).once('value').then((snapshot) => snapshot.val())
      if (noteReq) {
        const formsArray = Object.values(noteReq);
         const latestForm = formsArray.reduce((latest, current) => {
        return current.timestamp > (latest?.timestamp || 0) ? current : latest;
      }, null);

      if (latestForm) {
         const imageLink = {
          url: latestForm.file,
          fileName: `${latestForm.fileName} ${moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
          type: 'application/pdf',
          timestamp: moment(latestForm.timestamp).format('MM/DD/YYYY, hh:mm A'),
        };
        setMedicalNoteLink([imageLink]);  
      } 
      }
      }
    catch (error) { 
      console.error('Error fetching lab data:', error);
    }
  }
  

  // useEffect(() => {
  //   if (patient?.historyLabs && patient?.historyLabs[archiveID] && (pathName === 'labNote' || pathName === 'imagingNote')) {
  //     const labReq = patient?.historyLabs[archiveID];
  //     const labLinks = [];
  //     const imageLinks = [];

  //     const formsArray = labReq?.labForms ? Object.values(labReq.labForms) : [];

  //     const labForms = formsArray.filter(form => form.fileName?.includes("Lab_Requisition"));
  //     const imageForms = formsArray.filter(form => form.fileName?.includes("Image_Requisition"));


  //     if (labForms.length > 0) {
  //       const latestLab = labForms.reduce((latest, current) =>
  //         current.timestamp > (latest?.timestamp || 0) ? current : latest,
  //         null
  //       );
  //       if (latestLab) {
  //         labLinks.push({
  //           url: latestLab.file,
  //           fileName: `${latestLab.fileName} ${moment(latestLab.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //           type: "application/pdf",
  //           timestamp: moment(latestLab.timestamp).format('MM/DD/YYYY, hh:mm A')
  //         });
  //       }
  //     }

  //     if (imageForms.length > 0) {
  //       const latestImage = imageForms.reduce((latest, current) =>
  //         current.timestamp > (latest?.timestamp || 0) ? current : latest,
  //         null
  //       );
  //       if (latestImage) {
  //         imageLinks.push({
  //           url: latestImage.file,
  //           fileName: `${latestImage.fileName} ${moment(latestImage.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //           type: "application/pdf",
  //           timestamp: moment(latestImage.timestamp).format('MM/DD/YYYY, hh:mm A')
  //         });
  //       }
  //     }
        
  //     // Loop through labForms
  //     // Object.values(labReq.labForms).forEach((form) => {
  //     //   if (form.fileName.includes("Lab_Requisition")) {
  //     //     labLinks.push({
  //     //       url: form.file,
  //     //       fileName: `${form.fileName} ${moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //     //       type: "application/pdf",
  //     //       timestamp: moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')
  //     //     });
  //     //   }
  //     //   if (form.fileName.includes("Image_Requisition")) {
  //     //     imageLinks.push({
  //     //       url: form.file,
  //     //       fileName: `${form.fileName} ${moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //     //       type: "application/pdf",
  //     //       timestamp: moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')
  //     //     });
  //     //   }
  //     // });
  
  //     if (labLinks.length > 0) {
  //       setlabReq(labLinks);
  //     }
  //     if (imageLinks.length > 0) {
  //       setImageReq(imageLinks);
  //     }
  //   }else if (!patient?.historyLabs[archiveID] && (pathName === 'labNote' || pathName === 'imagingNote')){.  // !patient?.historyLabs[archiveID] need to remove this condition

  //      if(pathName === 'labNote') {
  //       tempLabData(archiveID);

  //      }
  //      if(pathName === 'imagingNote') {
  //       tempImageData(archiveID);
  //      }
      
  //   }

  //   if (patient?.historyMedicalNotes && patient?.historyMedicalNotes[archiveID] && pathName === 'medicalNote') {
  //     const medicalNote = patient?.historyMedicalNotes[archiveID];
  //     const noteLinks = [];
  
  //     // Object.values(medicalNote.notes).forEach((form) => {
  //     //   noteLinks.push({
  //     //       url: form.file,
  //     //       fileName: `${form.fileName} ${moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //     //       type: "application/pdf",
  //     //       timestamp: moment(form.timestamp).format('MM/DD/YYYY, hh:mm A')
  //     //     });
  //     // });
  
  //     // if (noteLinks.length > 0) {
  //     //   setMedicalNoteLink(noteLinks);

  //     // }
  //     if (medicalNote?.notes) {
  //       const notesArray = Object.values(medicalNote.notes);

  //       if (notesArray.length > 0) {
  //         // Find the latest by timestamp
  //         const latestNote = notesArray.reduce((latest, current) =>
  //           current.timestamp > (latest?.timestamp || 0) ? current : latest,
  //           null
  //         );

  //         if (latestNote) {
  //           noteLinks.push({
  //             url: latestNote.file,
  //             fileName: `${latestNote.fileName} ${moment(latestNote.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //             type: "application/pdf",
  //             timestamp: moment(latestNote.timestamp).format('MM/DD/YYYY, hh:mm A')
  //           });
  //         }
  //       }
  //     }
  //   }
  //   else if (!patient?.historyMedicalNotes[archiveID] && pathName === 'medicalNote') {

  //      tempNoteData(archiveID);

  //   }

  //   if (patient?.history_prescriptions && patient?.history_prescriptions[archiveID] && pathName === 'prescriptionNote') {
  //     const prescriptionNote = patient?.history_prescriptions[archiveID];
  //     let prescriptionLinks = [];
  //     if(prescriptionNote) {
  //       prescriptionLinks = [{
  //         url: prescriptionNote?.prescriptionspdf,
  //         fileName: `prescription${moment(prescriptionNote?.timestamp).format('MM/DD/YYYY, hh:mm A')}.pdf`,
  //         type: "application/pdf",
  //         timestamp: moment(prescriptionNote?.timestamp).format('MM/DD/YYYY, hh:mm A')
  //       }];
      
  //     }
  
  //     if (prescriptionLinks.length > 0) {
  //       setPrescriptionLink(prescriptionLinks);
  //     }
  //   }

  // }, [patient, pathName, archiveID]);
  

  const formik = useFormik({
    initialValues: {
      body: '',
      image: '',
    },
    validationSchema: Yup.object().shape({
      body: Yup.string().max(5000, 'Must be 5000 characters or less').required('Details are Required'),
      image: Yup.mixed(),
    }),
    onSubmit: async values => {
      try {
        setLoading(true)
        const { image, body } = values

        const urls = []
        // eslint-disable-next-line no-restricted-syntax
        for (const val of Object.values(image)) {

          const ref = storageRef().ref(
            `emailImages/${new Date().getTime()}`,
          )
          // eslint-disable-next-line no-await-in-loop
          const snapshot = await ref.put(val)
          // eslint-disable-next-line no-await-in-loop
          const str = await snapshot.ref.getDownloadURL()
          urls.push(str)
        }
        const formattedTime =  moment(delegateConvoObj?.timestamp).format('MM/DD/YYYY, hh:mm A');
        let receiverEmails = null

        receiverEmails = process.env.REACT_APP_ENVIRONMENT === 'staging' 
        ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online', adminDoctorEmail] 
        : ['ammara@yourdoctors.online', 'prescription@yourdoctors.online','labs@yourdoctors.online', 'triage@yourdoctors.online', adminDoctorEmail]; 
       
        if(mailReason === 'Decline Request' &&  (pathName === 'labNote' || pathName ===  'imagingNote')) {
          // if(labReq.length > 0 && pathName === 'labNote') {
          //   attachment = labReq
          // }
          // else if(imageReq.length > 0 && pathName === 'imagingNote') {
          //   attachment = imageReq
          // }
      
          let name = pathName === 'labNote' ? 'Lab Requisition' : 'Imaging Requisition';
          // add email for doctor also 
          receiverEmails = process.env.REACT_APP_ENVIRONMENT === 'staging' 
          ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online', adminDoctorEmail] 
          : ['prescription@yourdoctors.online','ammara@yourdoctors.online', adminDoctorEmail]; 
          console.log('innn lab imaging')
          sendMailReason = `${name} Declined - ${delegateConvoObj?.patientName} - ${formattedTime} `
         emailBody = `<html><body>Hi Team,<br><br>A ${name} request for ${delegateConvoObj?.patientName}, DOB ${delegateConvoObj?.DOB} has been declined by ${delegateConvoObj?.doctorName || ''} because of the following reason:<br><br>${body}<br><br>Please reach out to the patient at ${delegateConvoObj?.phone_number || ''} as soon as possible to Inform them of the decline and the specific reason.<br><br>Document the conversation with the patient in PHD updates.<br><br>Let the Supervising Physician and QA team know know once contact has been made or if you run into any issues.<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`

        }
        if(mailReason === 'Decline Request' &&  pathName === 'medicalNote' ) {
          console.log('innn medical note')
          // if(medicalNoteLink.length > 0) {
          //   attachment = medicalNoteLink
          // }
          receiverEmails = process.env.REACT_APP_ENVIRONMENT === 'staging' 
          ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online', adminDoctorEmail] 
          : ['ammara@yourdoctors.online', 'prescription@yourdoctors.online', adminDoctorEmail]; 
          sendMailReason = `Medical Note  Declined - ${delegateConvoObj?.patientName} - ${formattedTime} `
         emailBody = `<html><body>Hi Team,<br><br> A Medical Note request for ${delegateConvoObj?.patientName}, DOB ${delegateConvoObj?.DOB} has been declined by ${delegateConvoObj?.doctorName || ''}  because of the following reason:<br><br>${body}<br><br>Please reach out to the patient at ${delegateConvoObj?.phone_number || ''} as soon as possible to Inform them of the decline and the specific reason.<br><br>Document the conversation with the patient in PHD updates.<br><br>Let the Supervising Physician and QA team know know once contact has been made or if you run into any issues.<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`

        }

        if(mailReason === 'Decline Request' &&  pathName === 'prescriptionNote' ) {

          console.log('innn prescription')
          if(prescriptionLink.length > 0) {
            attachment = prescriptionLink
          }
          receiverEmails = process.env.REACT_APP_ENVIRONMENT === 'staging' 
          ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online', adminDoctorEmail] 
          : ['ammara@yourdoctors.online', 'prescription@yourdoctors.online', adminDoctorEmail]; 
          sendMailReason = `Prescription Declined - ${delegateConvoObj?.patientName} - ${formattedTime} `
          emailBody = `<html><body>Hi Team,<br><br> A prescription request for ${delegateConvoObj?.patientName}, DOB ${delegateConvoObj?.DOB} has been declined by ${delegateConvoObj?.doctorName || ''}  because of the following reason:<br><br>${body}<br><br>Please reach out to the patient at ${delegateConvoObj?.phone_number || ''} as soon as possible to Inform them of the decline and the specific reason.<br><br>Document the conversation with the patient in PHD updates.<br><br>Let the Supervising Physician and QA team know know once contact has been made or if you run into any issues.<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>Your Doctors Online Reporting System</body></html>`
 
        }

        if(mailReason === 'Suggestion Request' &&  pathName === 'prescriptionNote' ) {

          if(prescriptionLink.length > 0) {
            attachment = prescriptionLink
          }

          sendMailReason = `Edits Suggested for Prescription - ${delegateConvoObj?.patientName} - ${formattedTime} `
          emailBody = `<html><body>Hi Team,<br><br> A prescription request for ${delegateConvoObj?.patientName}, DOB ${delegateConvoObj?.DOB} has been returned by ${delegateConvoObj?.doctorName || ''}  with edits suggested:<br><br>${body}<br><br>Please request the QA team to contact the patient at ${delegateConvoObj?.phone_number || ''} as soon as possible to:<br><br>Explain the suggested edits and why they were requested.<br><br>Confirm the patient’s agreement with the changes or gather any questions/concerns.<br><br>
<br><br>Discuss next steps (e.g., updated prescription submission, alternative therapies, or scheduling a follow-up with the prescriber).<br><br>Document the conversation with the patient in PHD updates.<br><br>Please add comments to this ticket once the patient has been contacted. 
<br><br>Let the Supervising Physician and QA team know know once contact has been made or if you run into any issues.<br><br>Thanks for your prompt attention.
<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>   Your Doctors Online Reporting System</body></html>`
 
        }

        if(mailReason === 'Suggestion Request' &&  (pathName === 'labNote' || pathName === 'imagingNote') ) {
          // if(labReq.length > 0 && pathName === 'labNote') {
          //   attachment = labReq
          // }
          // else if(imageReq.length > 0 && pathName === 'imagingNote') {
          //   attachment = imageReq
          // }
          const update = {}
          if(pathName === 'labNote' && chatID) {
         
          update[`/tempUserNode/userLabResult/${chatID}/labForms`] = null
          }

           if(pathName === 'imagingNote' && chatID) {
         
          update[`/tempUserNode/userImageResult/${chatID}/labForms`] = null
          }

           await database.ref().update(update)

                  const name = pathName === 'labNote' ? 'Lab Requisition' : 'Imaging Requisition';
                      receiverEmails = process.env.REACT_APP_ENVIRONMENT === 'staging' 
                      ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online'] 
                      : ['prescription@yourdoctors.online',  'ammara@yourdoctors.online']; 
                      sendMailReason = `Edits Suggested for ${name}  - ${delegateConvoObj?.patientName} - ${formattedTime} `
                      emailBody = `<html><body>Hi Team,<br><br> A ${name} request for ${delegateConvoObj?.patientName}, DOB ${delegateConvoObj?.DOB} has been returned by ${delegateConvoObj?.doctorName || ''}  with edits suggested:<br><br>${body}<br><br>Please request the QA team to contact the patient at ${delegateConvoObj?.phone_number || ''} as soon as possible to:<br><br>Explain the suggested edits and why they were requested.<br><br>Confirm the patient’s agreement with the changes or gather any questions/concerns.<br><br>Discuss next steps (e.g., updated Lab/Imaging Requisition, or scheduling a follow-up.<br><br>
            <br><br>Document the conversation with the patient in PHD updates.<br><br>Please add comments to this ticket once the patient has been contacted. 
            <br><br>Let the Supervising Physician and QA team know know once contact has been made or if you run into any issues.<br><br>Thanks for your prompt attention.
            <br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>   Your Doctors Online Reporting System</body></html>`
 
        }
        
        if(mailReason === 'Suggestion Request' &&  pathName === 'medicalNote' ) {

          // if(medicalNoteLink.length > 0) {
          //   attachment = medicalNoteLink
          // }

          if(chatID) {
          const update = {}
          update[`/tempUserNode/userMedicalNote/${chatID}/notes`] = null
          await database.ref().update(update)
          }

          receiverEmails = process.env.REACT_APP_ENVIRONMENT === 'staging' 
          ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online'] 
          : ['ammara@yourdoctors.online', 'prescription@yourdoctors.online']; 
          sendMailReason = `Edits Suggested for Medical Note - ${delegateConvoObj?.patientName} - ${formattedTime} `
          emailBody = `<html><body>Hi Team,<br><br>A Medical Note request for ${delegateConvoObj?.patientName}, DOB ${delegateConvoObj?.DOB} has been returned by ${delegateConvoObj?.doctorName || ''}  with edits suggested:<br><br>${body}<br><br>Please request the QA team to contact the patient at ${delegateConvoObj?.phone_number || ''} as soon as possible to:<br><br>Explain the suggested edits and why they were requested.<br><br>Confirm the patient’s agreement with the changes or gather any questions/concerns.<br><br>Discuss next steps (e.g., updated Medical Note, or scheduling a follow-up.<br><br>
<br><br>Document the conversation with the patient in PHD updates.<br><br>Please add comments to this ticket once the patient has been contacted. 
<br><br>Let the Supervising Physician and QA team know know once contact has been made or if you run into any issues.<br><br>Thanks for your prompt attention.
<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br> Your Doctors Online Reporting System</body></html>`
 
        }
        if (mailReason === 'Support Query') {

          emailBody = `Hi Team,
A support request has been initiated by
Details / Edits Suggested:
${body || 'No additional details provided.'}
Thank you,
Your Doctors Online Reporting System
`;
          navigate(path.activeconsultationpage, { replace: true })
        }

        
        // const emailBody = `<html><body>Hi Team,<br><br>A Lab/Imaging requisition request for ${delegateConvoObj?.patientName}, ${delegateConvoObj?.DOB} has been declined because of the following reason:<br><br>${body}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>   Your Doctors Online Reporting System</body></html>`
        let payload = {
          'senderEmail': 'no-reply@yourdoctors.online',
          // 'receiverEmails': (process.env.REACT_APP_ENVIRONMENT === 'staging') ? ['usman@yourdoctors.online', 'shayan@yourdoctors.online', 'ghania@yourdoctors.online'] : ['ammara@yourdoctors.online', 'prescription@yourdoctors.online','amna@yourdoctors.online'],
          'receiverEmails': receiverEmails,
          'replyToEmail': email,
          'subject': `${sendMailReason} for Chat ID ${chatID}`,
          'emailBody': emailBody,
        }
        payload.files = []

        if (attachment && attachment.length > 0) {
          payload.files = [
            ...attachment.map((file) => ({
              url: file.url,
              fileName: file.fileName,
              type: file.type,
            }))
          ];
        }

        // if (urls.length) {
        //   payload.files = urls.map((url) => ({
        //     'url': url,
        //     'fileName': new Date().getTime(),
        //     'type': 'image/jpeg',
        //   }))
        // }
        if (urls.length) {
          payload.files = [
            ...payload.files, // Keep the existing attachments if any
            ...urls.map((url) => ({
              url: url,
             'fileName': new Date().getTime(),
              type: 'image/jpeg',
            }))
          ];
        }
        if (payload.files.length === 0) {
          delete payload.files;
        }
        const resp = await axios.post(emailUrl, payload)

        setLoading(false)
        if (mailReason === 'Decline Request' && pathName === 'prescriptionNote') {
          console.log('in decline prescription')
          const prescriptionNodeExists = await database.ref(`/prescriptionTracking/${delegateConvoObj?.id}`).once('value').then((snapshot) => snapshot.exists())
          let update = {}
          // update[`delegateChats/${chatID}/status`] = 'closed'
          // update[`delegateChats/${chatID}/action`] = 'declined'
          if(chatID) {
          update[`delegateChats/${chatID}/prescriptionStatus`] = 'declined'
          update[`delegateChats/${chatID}/actionReason`] = body || null
          update[`delegateChats/${chatID}/prescriptionDeclinedBy`] = me?.doctorName || null;
          update[`delegateChats/${chatID}/prescriptionDeclineReason`] = body || null
          }
          if (prescriptionNodeExists) {
            update[`/prescriptionTracking/${chatID}/status`] = 'declined'
            update[`/prescriptionTracking/${chatID}/events/${Date.now()}`] = {
              event: 'declined',
              doctorName: delegateConvoObj?.doctorName,
              reason: body || null,
            }
            update[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/declined`] = {
              doctorName: delegateConvoObj?.doctorName,
              reason: body || null,
              timestamp: Date.now(),
            }
            update[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/sentToPharmacy`] = null
            update[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/approved`] = null
            update[`/prescriptionTracking/${delegateConvoObj?.id}/userEvents/received`] = null
          }
          await database.ref().update(update)
          // navigate(path.pendingapproval, { replace: true })
        }
        
        if (mailReason === 'Decline Request' && (pathName ==='labNote' || pathName === 'imagingNote')) {
          let update = {}
          let id = null
          if(pathName === 'labNote') {
            id = `${chatID}_labs`;
          }
          else if(pathName === 'imagingNote'){
            id = `${chatID}_imaging`;          }
          else{
            id = chatID
          }
          const labImagingNodeExists = await database.ref(`/labTracking/${id}`).once('value').then((snapshot) => snapshot.exists())
          
          // update[`delegateChats/${chatID}/status`] = 'closed'
          // update[`delegateChats/${chatID}/action`] = 'declined'
          if(pathName === 'labNote' && chatID) {
            update[`/tempUserNode/userLabResult/${chatID}/labForms`] = null
            update[`delegateChats/${chatID}/labStatus`] = 'declined'
            update[`delegateChats/${chatID}/labDeclineReason`] = body || null
            update[`delegateChats/${chatID}/labnDeclinedBy`] = me?.doctorName || null;
          }
          else if(pathName === 'imagingNote' && chatID) {
            update[`/tempUserNode/userImageResult/${chatID}/labForms`] = null
            update[`delegateChats/${chatID}/imagingDeclineReason`] = body || null
            update[`delegateChats/${chatID}/imagingStatus`] = 'declined'
            update[`delegateChats/${chatID}/imagingDeclinedBy`] = me?.doctorName || null;
          }

          // update[`delegateChats/${chatID}/actionReason`] = body || null
          if (labImagingNodeExists) {
            update[`/labTracking/${id}/status`] = 'declined'
            update[`/labTracking/${id}/events/${Date.now()}`] = {
              event: 'declined',
              doctorName: delegateConvoObj?.doctorName,
              reason: body || null,
            }
            // update[`/labTracking/${delegateConvoObj?.id}/userEvents/declined`] = {
            //   doctorName: delegateConvoObj?.doctorName,
            //   reason: body || null,
            //   timestamp: Date.now(),
            // }
            // update[`/labTracking/${delegateConvoObj?.id}/userEvents/sentToPharmacy`] = null
            // update[`/labTracking/${delegateConvoObj?.id}/userEvents/approved`] = null
            // update[`/labTracking/${delegateConvoObj?.id}/userEvents/received`] = null
          }
          await database.ref().update(update)
          // navigate(path.pendingapproval, { replace: true })
        }

        if (mailReason === 'Decline Request' && pathName ==='medicalNote') {
          console.log('in decline medical note')
          const medicalNoteNodeExists = await database.ref(`/medicalNotes/${delegateConvoObj?.id}`).once('value').then((snapshot) => snapshot.exists())
          let update = {}
          
          // update[`delegateChats/${chatID}/status`] = 'closed'
          // update[`delegateChats/${chatID}/action`] = 'declined'
          if(chatID) {
          update[`delegateChats/${chatID}/medicalNoteStatus`] = 'declined'
          update[`tempUserNode/userMedicalNote/${chatID}/notes`] = null
          update[`delegateChats/${chatID}/medicalNoteDeclineReason`] = body || null
          update[`delegateChats/${chatID}/medicalNoteDeclinedBy`] = me?.doctorName || null;
          }

          // update[`delegateChats/${chatID}/actionReason`] = body || null
          if (medicalNoteNodeExists) {

             const payloadData ={
                        patientID: delegateConvoObj?.patientID,
                        chatID: delegateConvoObj?.id,
                        type: 'medicalNote',
                        adminDoctor : delegateConvoObj?.doctorName,
                        patientName: delegateConvoObj?.patientName,
                        labLink: null,
                        decline: true,
                      } 
                        await sendToUserLabAndImaging(
                                  qs.stringify(payloadData),
                                )
            update[`/medicalNotes/${delegateConvoObj?.id}/status`] = 'declined'
            update[`/medicalNotes/${delegateConvoObj?.id}/events/${Date.now()}`] = {
              event: 'declined',
              doctorName: delegateConvoObj?.doctorName,
              declineReason: body || null,
            }
          
          }
          await database.ref().update(update)

          // navigate(path.pendingapproval, { replace: true })
        }

        const delegateData = await fetchDelegateData(chatID);

        console.log('Delegate Data:', delegateData);
        if (delegateData) {
          console.log('inn ddDelegate Data:', delegateData);
            const delegateDataDone = await getDataFromFirebase(`/delegateChats/${chatID}`);          
            const allDone = await checkAllStatuses(delegateData, delegateDataDone, chatID);
          
            if (allDone) {
              console.log('All statuses are done, navigating to active consultation');
              let update = {}
               update[`delegateChats/${chatID}/status`] = 'active'
              if(chatID) update[`delegateChats/${chatID}/medicalNoteTextReason`] = null
               await database.ref().update(update)
              navigate(path.activeconsultationpage, { replace: true });
            } else {
              console.log('Not all statuses are done, navigating to pending approval');
              query.set('archiveId', archiveID)
              navigateToConsultation(archiveID);
            }

        }

        if (mailReason === 'Suggestion Request') {
          navigate(path.pendingapproval, { replace: true })
        }
      
      } catch (e) {
        // eslint-disable-next-line no-undef
        alert('Something went wrong!')
        setLoading(false)
        console.log('Error', e)
      }

    },
  })

  return (
    <div>

      <BackComponent
        title={'Back'}
      />
      <div className={style.mailBox}>
        
        <form className={style.input} onSubmit={formik.handleSubmit} encType="multipart/form-data">
          <div>
            <p className={style.reason}>{mailReason}</p>
          </div>

          <label className={style.label}>Enter Detail</label>
          <textarea rows={6} cols={70} className={style.textArea}
                    id="body"
                    name="body"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.body}
          />
          {formik.touched.body && formik.errors.body ? (
            <div className={style.error}>{formik.errors.body}</div>
          ) : null}
          <br></br>

          <label className={style.label}>Attachment</label>
          <input
            id="image"
            name="image"
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageSelection}
            // onChange={(event) => {
            //   formik.setFieldValue("image", event.currentTarget.files[0]);
            // }}
            onBlur={formik.handleBlur}
          />
          {formik.touched.image && formik.errors.image ? (
            <div className={style.error}>{formik.errors.image}</div>
          ) : null}

          {loading ? <div className={style.sendEmailButton}><Spinner color="#DF7467" isLoading={loading} /></div> :
            <button className={style.sendEmailButton} type="submit" value="Submit">Submit</button>}

        </form>
      </div>
    </div>
  )

}

export default SendMail

const getDataFromFirebase = async (path) => {
  const snapshot = await database.ref(path).once('value');
  return snapshot.val();
};
const fetchDelegateData = async (chatID) => {
  let data = await getDataFromFirebase(`/archiveConversations/${chatID}`);
  if (data) {
    console.log('Data found in Archive Conversations:', data);
    return data;
  }

  data = await getDataFromFirebase(`/openconversations/${chatID}`);
  if (data) {
    return data;
  }

  data = await getDataFromFirebase(`/delegateChats/${chatID}`);
  if (data) {
    return data;
  }

  console.log('No data found in any path.');
  return null;
};
// const checkAllStatuses = async (delegateData, delegateConvoObj) => {
//   const statusMapping = {
//     labRequisitionData: "labStatus",
//     imagingData: "imagingStatus",
//     medicalNotesData: "medicalNoteStatus",
//     prescriptionData: "prescriptionStatus",
//   };
//     const presentDataKeys = Object.keys(statusMapping).filter(
//     (key) => delegateData[key]
//   );


//   if (presentDataKeys.length === 0) {
//     console.log("No data to track, navigating to pending");
//     return false;
//   }
//     const statuses = presentDataKeys.map((key) => ({
//     key,
//     status: delegateConvoObj[statusMapping[key]],
//   }));

//   console.log("Statuses found:", statuses);

//   const allProcessed = statuses.every(
//     (item) => item.status === "approved" || item.status === "declined"
//   );

//   console.log("All processed:", allProcessed);

//   return allProcessed;
// };


